<div *ngIf="isActive">
    <ng-content></ng-content>
</div>